import ChatBotNoApiModel from './ChatBotNoApiModel'
import ChatBotTipoNoApiAutorizacaoTiposEnum from './ChatBotTipoNoApiAutorizacaoTiposEnum'
import ChatBotTipoNoApiParametroTiposEnum from './ChatBotTipoNoApiParametroTiposEnum'

/* eslint-disable lines-between-class-members */
class NodeChatBotModel {
  constructor({
    id = 0,
    noPaiId = null,
    texto = null,
    numero = 0,
    chatBotNoTipoId = 0,
    chatBotArvoreDestinoId = 0,
    nosFilhos = [],
    textoSelecao = null,
    notaMenorQue = null,
    perguntaAdicional = null,
    adicionarSubNosParaVoltarEEncerrar = false,
    arquivoNome = null,
    arquivoConteudo = null,
    mensagemEncerramento = null,
    filaId = null,
    formularioId = null,
    atendimentoOffline = false,
    atendimentoOfflineMensagem = null,
    possuiHorarioAtendimento = false,
    horarioAtendimentoInicio = null,
    horarioAtendimentoFim = null,
    horarioAtendimentoMensagem = null,
    diasAtendimento = null,
    botaoHeader = null,
    botaoBody = null,
    botaoFooter = null,
    botaoOpcaoTitle = null,
    listaHeader = null,
    listaBody = null,
    listaFooter = null,
    listaBotao = null,
    listaOpcaoTitle = null,
    listaOpcaoDescription = null,
    arquivoStorageId = null,
    chatGptAssistantKey = null,
    chatGptApiKey = null,
    coletarDadosClienteAntesPreenchimentoFormulario = false,
    tipoAgendamentoId = null,
    agenteId = null,
    agenteDisponibilidadePeriodoId = null,
    agenteDisponibilidadeId = null,
    apiInfo = new ChatBotNoApiModel(),
    mensagemSucessoTicket = null // ✅ ADICIONAR
  } = {}) {
    this.id = id
    this.noPaiId = noPaiId
    this.texto = texto
    this.numero = numero
    this.nosFilhos = nosFilhos
    this.chatBotNoTipoId = chatBotNoTipoId
    this.textoSelecao = textoSelecao
    this.notaMenorQue = notaMenorQue
    this.perguntaAdicional = perguntaAdicional
    this.adicionarSubNosParaVoltarEEncerrar = adicionarSubNosParaVoltarEEncerrar
    this.arquivoNome = arquivoNome
    this.arquivoConteudo = arquivoConteudo
    this.mensagemEncerramento = mensagemEncerramento
    this.filaId = filaId
    this.formularioId = formularioId
    this.atendimentoOffline = atendimentoOffline
    this.atendimentoOfflineMensagem = atendimentoOfflineMensagem
    this.possuiHorarioAtendimento = possuiHorarioAtendimento
    this.horarioAtendimentoInicio = horarioAtendimentoInicio
    this.horarioAtendimentoFim = horarioAtendimentoFim
    this.horarioAtendimentoMensagem = horarioAtendimentoMensagem
    this.chatBotArvoreDestinoId = chatBotArvoreDestinoId
    this.diasAtendimento = diasAtendimento
    this.botaoHeader = botaoHeader
    this.botaoBody = botaoBody
    this.botaoFooter = botaoFooter
    this.botaoOpcaoTitle = botaoOpcaoTitle
    this.listaHeader = listaHeader
    this.listaBody = listaBody
    this.listaFooter = listaFooter
    this.listaBotao = listaBotao
    this.listaOpcaoTitle = listaOpcaoTitle
    this.listaOpcaoDescription = listaOpcaoDescription
    this.arquivoStorageId = arquivoStorageId
    this.chatGptAssistantKey = chatGptAssistantKey
    this.chatGptApiKey = chatGptApiKey
    this.coletarDadosClienteAntesPreenchimentoFormulario = coletarDadosClienteAntesPreenchimentoFormulario
    this.tipoAgendamentoId = tipoAgendamentoId
    this.agenteId = agenteId
    this.agenteDisponibilidadePeriodoId = agenteDisponibilidadePeriodoId
    this.agenteDisponibilidadeId = agenteDisponibilidadeId
    this.apiInfo = apiInfo
    this.mensagemSucessoTicket = mensagemSucessoTicket // ✅ ADICIONAR
  }

  static preencherHorario(data) {
    const partesInicio = data.horarioAtendimentoInicio.split(':')
    const partesFim = data.horarioAtendimentoFim.split(':')

    if (partesInicio.length === 2) {
      partesInicio.push('00')
      data.horarioAtendimentoInicio = partesInicio.join(':')
    }

    if (partesFim.length === 2) {
      partesFim.push('00')
      data.horarioAtendimentoFim = partesFim.join(':')
    }
  }

  static verificarTipoBotaoLista(data, id) {
    if (id === 7) {
      data.listaHeader = null
      data.listaBody = null
      data.listaFooter = null
      data.listaBotao = null
      data.listaOpcaoTitle = null
      data.listaOpcaoDescription = null
      data.texto = null
    }

    if (id === 8) {
      data.botaoOpcaoTitle = null
      data.botaoHeader = null
      data.botaoBody = null
      data.botaoFooter = null
      data.texto = null
    }
  }

  static tipoIdTexto(data, tipo) {
    const dataToChange = data

    dataToChange.filaId = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdFila(data, tipo) {
    const dataToChange = data

    if (dataToChange.possuiHorarioAtendimento) {
      this.preencherHorario(dataToChange)
    } else {
      dataToChange.possuiHorarioAtendimento = false
      dataToChange.horarioAtendimentoInicio = null
      dataToChange.horarioAtendimentoFim = null
      dataToChange.horarioAtendimentoMensagem = null
    }
    if (!dataToChange.diasAtendimento.length) {
      dataToChange.diasAtendimento = null
    }

    dataToChange.textoSelecao = null
    dataToChange.notaMenorQue = null
    dataToChange.perguntaAdicional = null
    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdVoltar(data, tipo) {
    const dataToChange = data

    dataToChange.textoSelecao = null
    dataToChange.notaMenorQue = null
    dataToChange.perguntaAdicional = null
    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.filaId = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdEncerrar(data, tipo) {
    const dataToChange = data

    dataToChange.textoSelecao = null
    dataToChange.notaMenorQue = null
    dataToChange.perguntaAdicional = null
    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.filaId = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdArvore(data, tipo) {
    const dataToChange = data

    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.filaId = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdBotao(data, tipo) {
    const dataToChange = data

    dataToChange.textoSelecao = null
    dataToChange.notaMenorQue = null
    dataToChange.perguntaAdicional = null
    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.filaId = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdLista(data, tipo) {
    const dataToChange = data

    dataToChange.textoSelecao = null
    dataToChange.notaMenorQue = null
    dataToChange.perguntaAdicional = null
    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.filaId = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdFormulario(data, tipo) {
    const dataToChange = data

    dataToChange.textoSelecao = null
    dataToChange.notaMenorQue = null
    dataToChange.perguntaAdicional = null
    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.diasAtendimento = null
    dataToChange.chatGptAssistantKey = null
    dataToChange.chatGptApiKey = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdChatGPT(data, tipo) {
    const dataToChange = data

    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.tipoAgendamentoId = null
    dataToChange.agenteId = null
    dataToChange.agenteDisponibilidadePeriodoId = null
    dataToChange.agenteDisponibilidadeId = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdNotaPesquisa(data) {
    return {
      id: data.id,
      noPaiId: data.noPaiId,
      texto: data.texto,
      numero: parseInt(data.numero, 10),
      textoSelecao: data.textoSelecao,
      notaMenorQue: data.notaMenorQue,
      perguntaAdicional: data.perguntaAdicional,
    }
  }

  static tipoAgendamentoId(data, tipo) {
    const dataToChange = data

    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null
    dataToChange.apiInfo = null

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }

  static tipoIdApi(data, tipo) {
    const dataToChange = data

    dataToChange.adicionarSubNosParaVoltarEEncerrar = false
    dataToChange.arquivoNome = null
    dataToChange.arquivoConteudo = null
    dataToChange.arquivoStorageId = null
    dataToChange.mensagemEncerramento = null
    dataToChange.formularioId = null
    dataToChange.possuiHorarioAtendimento = false
    dataToChange.horarioAtendimentoInicio = null
    dataToChange.horarioAtendimentoFim = null
    dataToChange.horarioAtendimentoMensagem = null
    dataToChange.chatBotArvoreDestinoId = null
    dataToChange.atendimentoOffline = null
    dataToChange.diasAtendimento = null
    dataToChange.coletarDadosClienteAntesPreenchimentoFormulario = null

    if (dataToChange.apiInfo.apiTipoAutorizacaoId === ChatBotTipoNoApiAutorizacaoTiposEnum.BearerToken) {
      dataToChange.apiInfo.apiUserName = null
      dataToChange.apiInfo.apiPassword = null
    }

    if (dataToChange.apiInfo.apiTipoAutorizacaoId === ChatBotTipoNoApiAutorizacaoTiposEnum.BasicAuth) {
      dataToChange.apiInfo.apiBearerToken = null
    }

    if (dataToChange.apiInfo.apiTipoParametroId !== ChatBotTipoNoApiParametroTiposEnum.Lista) {
      dataToChange.apiInfo.parametros = null
    }

    if (dataToChange.apiInfo.apiTipoParametroId !== ChatBotTipoNoApiParametroTiposEnum.Body) {
      dataToChange.apiInfo.apiParametroJsonBody = null
    }

    this.verificarTipoBotaoLista(dataToChange, tipo)

    return dataToChange
  }
}

export default NodeChatBotModel
